import { ApiStatuses } from '../../../../global/models/api-model';

export interface Group {
    name: string;
    group_id: number;
    client_number: string;
}

export interface GroupsState {
    groups: Group[];
    currentGroup: Group;
    groupsLoaded: boolean;
    adminAddStatus: ApiStatuses;
}

export enum GroupsActionTypes {
    SET_GROUPS = 'SET_GROUPS',
    SET_GROUPS_LOADED = 'SET_GROUPS_LOADED',
    SET_CURRENT_GROUP = 'SET_CURRENT_GROUP',
    ADD_ADMIN_STATUS = 'ADD_ADMIN_STATUS',
    CLEAR = 'CLEAR',
}

export enum GroupAdminTypes {
    Junior = 'JuniorGroupPlanAdmin',
    Senior = 'SeniorGroupPlanAdmin',
}